/**
 * URL-related utility functions
 */

/**
 * Safely parse a URL string and return a structured result
 * @param url - The URL string to parse
 * @returns Object with either success result containing URL object or error details
 */
export function parseUrl(
  url: string,
): { kind: "ok"; result: URL } | { kind: "error"; message: string; error: any } {
  try {
    return { kind: "ok", result: new URL(url) }
  } catch (error) {
    return { kind: "error", message: `parseUrl: Invalid URL - ${url}`, error }
  }
}
